import { marked } from 'marked';

$(() => {
  // marked.jsのデフォルトオプション
  marked.setOptions({ sanitize: true });

  // パース処理のラッパ
  function parseMarkdown(textContent, $target) {
    marked(textContent, (_, content) => $target.html(content));
  }

  // 読み込んですぐパースする処理

  $('.js-markdown').each((_, markdown) => {
    parseMarkdown($(markdown).text(), $($(markdown).data('target')));
  });

  // ライブプレビュー機能
  // keyupでガンガンパースするとブラウザがかわいそうなので、
  // timeoutに突っ込んで0.3秒後にパースするようにしてる
  let timeoutId;
  $('.js-markdown-live').on('keyup', e => {
    const $markdownLive = $(e.currentTarget);

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(() => {
      parseMarkdown($markdownLive.val(), $($markdownLive.data('target')));
    }, 300);
  });
});
